import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { axiosInstnace as Axios } from "../../../util/util";
import { endPoints } from "../../../config";
import DatePicker from "react-datepicker";

const SynchronizePaymentsModel = ({ isShown, hide, close }) => {
  //Set initial state
  const [paymentDate, handlePaymentDate] = useState(undefined);

  const closePopup = () => {
    hide();
  };
  

  const submitOfflinePaymentRecord = async (e) => {
    e.preventDefault();

    let offlinePaymentRecord = await Axios.get(`${endPoints.updateOfflinePayments}?day=${moment(paymentDate).format('DD')}&month=${moment(paymentDate).format('MM')}&year=${moment(paymentDate).format('YYYY')}` );

    
    if(offlinePaymentRecord.data && offlinePaymentRecord.data.data && offlinePaymentRecord.data.data.message){
      hide('success', offlinePaymentRecord.data.data.message);
    }else{
      hide('failed', offlinePaymentRecord.data.error);
    }
  }

  const resetForm = () => {

  }

  return isShown ? (
    <div className="dashboardContainer remark-popup">
      <div className="modal-overlay">
        <div
          className="modal-wrapper"
          aria-modal
          aria-hidden
          role="dialog"
        >
          <div className="modal">
            <div className="modal-head-cross rate-modal">
              <button
                type="button"
                className="modal-close-button"
                onClick={(e)=>{
                  resetForm();
                  close();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
                <div className="editNonFct-header modal-header">
                  <div className="running_cap_head">
                    <h2 className="camp_head">Synchronize Payments</h2>
                    <div className="camp_right">
                      
                    </div>
                  </div>
                </div>

                <div className=" modal-body">
                  <div className="bg-white">
                    <div className="popupCampaign-container">
                      <div className="campaign-input master-inputs">
                        <div className="dashboard-content userListing-dashboard bg-white table-responsive">
                          
                          <label for="paymentid">Select date</label>

                          <div className="startDate">
                            <DatePicker
                              selected={paymentDate}
                              onChange={(date) => handlePaymentDate(date)}
                              dateFormatCalendar={"MMM yyyy"}
                              placeholderText=" Select Date"
                              isClearable
                            />
                          </div>

                          <div className="create_camp_btn" style={{width: "100%", marginTop: "50px"}}>
                            <button style={{float: "right", padding: '10px', color: 'white'}} onClick={(e)=>{submitOfflinePaymentRecord(e)}}>Submit</button>
                          </div>
                        </div>
                        
                      </div>
                      {/*<div className="create-camp nonfct-submit">
                  <button onClick={handleContactsUsRemarks}>SAVE CHANGES</button>
                </div>*/}
                    </div>
                  </div>
                </div>
              </div>
          </div>
          
        </div>
      </div>
      <ToastContainer />
    </div>
  ) : null;
};

export default SynchronizePaymentsModel;



// WEBPACK FOOTER //
// ./web/components/admin/manageCampaign/SynchronizePaymentsModel.js